import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styles from "./CSO21Content.module.scss";
import { YoutubeBox } from "@climate-science/component-library";
import { WINNERS } from "../consts";
import Team, { place } from "@cs/components/composite/team/Team";

const CSO21Content: FC = () => {
  const { t } = useTranslation("olympiad");

  return (
    <div className={styles.purpleWrap}>
      <section className={styles.cso21}>
        <h2 className={styles.title}>{t("finals-ceremony-at-un")}</h2>
        <YoutubeBox
          css={""}
          title={t("finals-ceremony-at-un") + ' video'}
          youtubeId="CjJ3cCRP9FU"
        />
      </section>
      <section className={styles.info}>
        <article className={styles.article1}>
          <p>
            <Trans
              t={t}
              i18nKey="cso21.content-text-1"
              components={[
                <strong key={"0"}/>
              ]}
            />
          </p>
        </article>
        <article className={styles.article2}>
          <p>
            <Trans
              t={t}
              i18nKey="cso21.content-text-2"
              components={[
                <strong key={"0"}/>
              ]}
            />
          </p>
        </article>
      </section>
      <section className={styles.winners}>
        <h2 className={styles.winnersTitle}>
          {t("cso21.winners-title")}
        </h2>
        {
          Object.keys(WINNERS).map((place, i) => (
            <Team key={i}
              team={WINNERS[place as place]}
              title={t(`cso21.winners-${place}-place`)}
              subtitle={t(`cso21.winners-${place}-prize`)}
              description={t(`cso21.winners-${place}-description`)}
            />
          ))
        }
      </section>
    </div>
  );
};

export default CSO21Content;
